// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"346":"c8b31a99","518":"bb3e4123"}[chunkId] + ".chunk.css";
};